const _ = require('lib/underscore')
const old_color_themes = require('data/color_themes')

module.exports = function getLayoutColor(user) {
    if (! user) throw new Error('getLayoutColor requires a user')
    if (! user.layout) throw new Error('getLayoutColor requires user.layout')

    let current_color

    const color_theme_id = user.layout.color_theme_id

    // if user has a color_theme_id, use that color
    if (color_theme_id) {
        const theme = _.findWhere(old_color_themes, { id: color_theme_id })
        current_color = theme && theme.swatch
    }

    // if current_color is still undefined, use layout.color
    if (! current_color) current_color = user.layout.color

    // if current_color is the name of a theme, use that theme's swatch
    const theme = _.findWhere(old_color_themes, { id: current_color })
    if (theme) current_color = theme.swatch

    // if current_color is still undefined, use sunset swatch
    if (! current_color) {
        const orange_theme = _.findWhere(old_color_themes, { id: 'sunset' })
        current_color = orange_theme.swatch
    }

    return current_color
}
